import { Link } from 'react-router-dom';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="relative bg-ink-900 border-t border-white/5 mt-24">
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <Logo />
          <p className="mt-5 text-sm text-white/60 leading-relaxed">
            Intelligent digital solutions, AI-powered automation and modern technology experiences that move businesses forward.
          </p>
          <div className="flex gap-3 mt-5">
            {['linkedin-fill', 'instagram-line'].map((i) => (
              <a key={i} href="#" className="w-9 h-9 flex items-center justify-center rounded-md border border-white/10 text-white/70 hover:text-white hover:border-neon-500 transition">
                <i className={`ri-${i}`} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-4"><a href="#quick-links" className="hover:text-neon-300">Quick Links</a></h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/" className="hover:text-white">Home</Link></li>
            <li><Link to="/about" className="hover:text-white">About</Link></li>
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/portfolio" className="hover:text-white">Portfolio</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-4"><a href="#services" className="hover:text-neon-300">Services</a></h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/services/website-development" className="hover:text-white">Website Development</Link></li>
            <li><Link to="/services/ai-automation" className="hover:text-white">AI Agents & Automation</Link></li>
            <li><Link to="/services/seo-marketing" className="hover:text-white">SEO & Digital Marketing</Link></li>
            <li><Link to="/services/video-editing" className="hover:text-white">Video Editing</Link></li>
            <li><Link to="/services/social-analytics" className="hover:text-white">Social Media Analytics</Link></li>
            <li><Link to="/services/hosting" className="hover:text-white">Hosting & Domain</Link></li>
            <li><Link to="/services/meta-ads" className="hover:text-white">Meta Ads</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-4"><a href="#contact" className="hover:text-neon-300">Contact</a></h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li className="flex items-center gap-2"><i className="ri-mail-line text-neon-400" /> <a href="mailto:formacodetech@gmail.com" className="hover:text-white transition">formacodetech@gmail.com</a></li>
            <li className="flex items-center gap-2"><i className="ri-mail-send-line text-neon-400" /> <a href="mailto:info@formacodetech.com" className="hover:text-white transition">info@formacodetech.com</a></li>
            <li className="flex items-center gap-2"><i className="ri-whatsapp-line text-neon-400" /> 03706620393</li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/5">
        <div className="mx-auto max-w-7xl px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© 2026 FormaCode Technologies. All rights reserved.</p>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms & Conditions</Link>
            <Link to="/cookies" className="hover:text-white">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}